"use strict";

import vanillaLazyload from "vanilla-lazyload";
export const initLazyLoad = function initLazyLoad() {
  // Default is only `.lazy`; this theme often uses `data-src` without that class (e.g. subnav__cta--image).
  return new vanillaLazyload({
    elements_selector: "img[data-src], .lazy",
  });
};
export const initLazyBackground = function initLazyBackground() {
  return new vanillaLazyload({
    elements_selector: "[data-lazy-background]",
    data_bg: "src",
  });
};
